import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetAppRegisteredStudentsPerGroupUseCaseInterface } from 'domain/usecases';
import { IAppRegisteredStudentsPerGroupFilters } from 'presentation/app/modules/Reports/models/app-registered-students-per-group-filters';

interface IActivitiesAnalyticalPerGroup {
  appRegisteredStudentsPerGroupListData: GetAppRegisteredStudentsPerGroupUseCaseInterface.Result;
  appRegisteredStudentsPerGroupFilters: IAppRegisteredStudentsPerGroupFilters;
}

interface IPayloadAppRegisteredStudentsPerGroupListData
  extends PayloadAction<GetAppRegisteredStudentsPerGroupUseCaseInterface.Result> {}

interface IPayloadAppRegisteredStudentsPerGroupFilters
  extends PayloadAction<IAppRegisteredStudentsPerGroupFilters> {}

const initialState: IActivitiesAnalyticalPerGroup = {
  appRegisteredStudentsPerGroupListData: [],
  appRegisteredStudentsPerGroupFilters: null,
};

export const AppRegisteredStudentsPerGroupSlice = createSlice({
  name: 'activity-report-internship',
  initialState,
  reducers: {
    loadAppRegisteredStudentsPerGroupListData: (
      state,
      action: IPayloadAppRegisteredStudentsPerGroupListData,
    ) => {
      state.appRegisteredStudentsPerGroupListData = action.payload;
    },
    clearAppRegisteredStudentsPerGroupListData: (state) => {
      state.appRegisteredStudentsPerGroupListData = [];
    },
    loadAppRegisteredStudentsPerGroupFilters: (
      state,
      action: IPayloadAppRegisteredStudentsPerGroupFilters,
    ) => {
      state.appRegisteredStudentsPerGroupFilters = action.payload;
    },
    clearAppRegisteredStudentsPerGroupFilters: (state) => {
      state.appRegisteredStudentsPerGroupFilters = null;
    },
  },
});

export const {
  loadAppRegisteredStudentsPerGroupListData,
  clearAppRegisteredStudentsPerGroupListData,
  loadAppRegisteredStudentsPerGroupFilters,
  clearAppRegisteredStudentsPerGroupFilters,
} = AppRegisteredStudentsPerGroupSlice.actions;

export default AppRegisteredStudentsPerGroupSlice.reducer;
